import {
  createRoutesFromElements,
  Route,
  createBrowserRouter
} from 'react-router-dom';
import { BaseLayout } from '@/layouts';
import type { MenusObj } from '@/typings/custom';
import { RootErrorBoundary, staticMenus } from './routes';

const createRputeByMapMenus = (menu: MenusObj[]): JSX.Element => {
  return (
    <>
      {menu.map(item => {
        if (item.children) {
          const { path, element, isDefault, children } = item;
          const arr = [{ path, element, isDefault }, ...children];
          return createRputeByMapMenus(arr);
        }
        if (item.path && item.element) {
          return (
            <>
              {item.isDefault && <Route index element={item.element} />}
              <Route path={item.path} element={item.element} key={item.path} />
            </>
          );
        }
      })}
    </>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route path="/" element={<BaseLayout />}>
        {createRputeByMapMenus(staticMenus)}
      </Route>
      <Route path="/:site_name" element={<BaseLayout />}>
        {createRputeByMapMenus(staticMenus)}
      </Route>
    </Route>
  )
);

export default router;
